import { motion } from 'framer-motion';

export default function LoadingPage({ progress }) {
  const showProgress = typeof progress === 'number';
  const displayProgress = showProgress ? progress : 25;

  return (
    <div className="w-full h-screen flex items-center justify-center bg-loading">
      <motion.div
        className="text-center w-64"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <div className="relative w-28 h-28 mx-auto mb-6 flex items-center justify-center">
          {/* Circular Progress SVG */}
          <motion.svg
            className="w-full h-full transform -rotate-90"
            viewBox="0 0 100 100"
            animate={!showProgress ? { rotate: 270 } : {}}
            transition={
              !showProgress
                ? {
                    duration: 1.5,
                    repeat: Infinity,
                    ease: 'linear',
                  }
                : {}
            }
          >
            {/* Background Circle */}
            <circle
              cx="50"
              cy="50"
              r="42"
              className="stroke-divider"
              strokeWidth="6"
              fill="transparent"
            />
            {/* Progress Circle */}
            <motion.circle
              cx="50"
              cy="50"
              r="42"
              className="stroke-rose-accent"
              strokeWidth="6"
              fill="transparent"
              strokeDasharray="263.89"
              initial={{ strokeDashoffset: 263.89 }}
              animate={{
                strokeDashoffset: 263.89 - (263.89 * displayProgress) / 100,
              }}
              transition={{ ease: 'easeOut', duration: 0.15 }}
              strokeLinecap="round"
            />
          </motion.svg>
          {/* Percentage Text in the middle */}
          <div className="absolute flex flex-col items-center justify-center">
            <span className="text-xl font-normal-bold text-wedding-heading">
              {showProgress ? `${Math.round(progress)}%` : '...'}
            </span>
          </div>
        </div>

        <motion.p
          className="text-2xl font-normal-bold text-wedding-heading"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Loading...
        </motion.p>
      </motion.div>
    </div>
  );
}
